let idsNavContDownload = [
  {
    navId: "windows_nav",
    contentId: "windows_content",
    paramForUrl: "windows",
  },
  {
    navId: "macos_nav",
    contentId: "macos_content",
    paramForUrl: "macos",
  },
  {
    navId: "linux_nav",
    contentId: "linux_content",
    paramForUrl: "linux",
  },
  {
    navId: "lastest_beta_nav",
    contentId: "lastes_beta_content",
    paramForUrl: "lastes-beta",
  },
  {
    navId: "applinks_nav",
    contentId: "applinks_content",
    paramForUrl: "applinks",
  },
  {
    navId: "other_nav",
    contentId: "other_content",
    paramForUrl: "other",
  },
];

for (let obj of idsNavContDownload) {
  let check = document.querySelector("#" + obj.navId);
  check &&
    document
      .querySelector("#" + obj.navId)
      .addEventListener("click", function () {
        removeClassInElements(
          ".container_download_content",
          "active_download_content"
        );
        removeClassInElements(".nav_download_item", "active_border_bottom");

        check &&
          document
            .querySelector("#" + obj.navId)
            .classList.add("active_border_bottom");

        check &&
          document
            .querySelector("#" + obj.contentId)
            .classList.add("active_download_content");

        setParamToUrl("download", obj.paramForUrl);

      });
}

let url = new URL(window.location.href);

// CHECK URL PARAM "DOWNLOAD"
let downloadParam = url.searchParams.get("download");
const urlPathname = window.location.pathname.replace(/[/]/g, '');

if(downloadParam === null && urlPathname === "download") {
  console.log("in download page");
  const currentTabId = document.querySelector(".nav_download_item.active_border_bottom").id;  
  let currentObj = idsNavContDownload.find(x => x.navId === currentTabId);
  setParamToUrl("download", currentObj.paramForUrl);
} else {
  let currentObj = idsNavContDownload.find(x => x.paramForUrl === downloadParam);
  if(currentObj !== undefined) {
    document.getElementById(currentObj.navId).click();
    
    document.querySelector(".nav_download").scrollIntoView({ block: "center", behavior: "smooth" });
  }
}

// SCROLL TO BLOCK
let idParam = url.searchParams.get("id");
if (idParam !== null) {
  const activeTabContent = document.querySelector(`.container_download_content.active_download_content`);
  let idEl = activeTabContent.querySelector(`[id='${idParam}']`)
  if(idEl !== null) {
    idEl.querySelector(".table_resources").classList.add("open");
    idEl.querySelector(".icon").classList.toggle("arrow_rotate");
    hideHeaderBlock();
    idEl.scrollIntoView({ block: "center", behavior: "smooth" });
  }
}
function hideHeaderBlock() {
  let headerScroll = document.querySelector(".header");
  let sloganScroll = document.querySelector(".menu_slogan_bg");
  let secondHeaderScroll = document.querySelector(".second_header");
  let bodyPage = document.querySelector(".container_body_page");
  headerScroll.classList.add("hide");
  sloganScroll.classList.add("hide");
  secondHeaderScroll.classList.add("hide");
  bodyPage.classList.add("padding_top");
}
// END SCROLL TO BLOCK

// SET PRODUCT COLOR

if (typeof(productColor) !== 'undefined') {
  const addCSS = s => document.head.appendChild(document.createElement("style")).innerHTML=s;

  addCSS(".nav_download_item.active_border_bottom{ border-color:" + productColor + "; }")
}

// END SET PRODUCT COLOR

// SET PARAMS TO URL WITHOUT RELOAD PAGE
function setParamToUrl(paramName, paramValue) {
  const url = new URL(window.location.href);
  url.searchParams.set(paramName, paramValue);
  window.history.replaceState(null, null, url);
}

export function removeClassInElements(el, removeClass) {
  let allContent = document.querySelectorAll(el);
  for (let content of allContent) {
    content.classList.remove(removeClass);
  }
}

// SHOW/HIDE BLOCK DOWNLOAD MORE INFO
function toggleMoreInfo(btnEl) {
  let blockText = btnEl.closest(".container_download_content_text")
    .nextElementSibling;
  let btnText = btnEl.querySelector(".text_download_more");
  let btnArrow = btnEl.querySelector(".arrow");
  if (blockText.classList.contains("open")) {
    btnText.innerText = "More info";
  } else {
    btnText.innerText = "Close";
  }
  blockText.classList.toggle("open");
  btnArrow.classList.toggle("rotate_arrow");
}

let btnsMoreInfo = document.querySelectorAll(".btn_download_more");
if (btnsMoreInfo.length > 0) {
  for (let btn of btnsMoreInfo) {
    btn.addEventListener("click", function () {
      toggleMoreInfo(this);
    });
  }
}
let closeBtnsBl = document.querySelectorAll(".btn_close_more_info");
if (closeBtnsBl.length > 0) {
  for (let closeBtn of closeBtnsBl) {
    closeBtn.addEventListener("click", function () {
      let blockText = this.closest(".block_download_more_info");
      let btnMoreInfo = blockText.previousElementSibling.querySelector(
        ".btn_download_more"
      );
      blockText.classList.remove("open");
      btnMoreInfo.querySelector(".text_download_more").innerText = "More info";
      btnMoreInfo.querySelector(".arrow").classList.toggle("rotate_arrow");
    });
  }
}
// END SHOW/HIDE BLOCK DOWNLOAD MORE INFO

// SHOW/HIDE RESOURCES
let blocksResources = document.querySelectorAll(".block_resources");
for (let i = 0; i < blocksResources.length; i++) {
  let headResourse = blocksResources[i].querySelector(".block_resources_head");
  headResourse.addEventListener("click", function () {
    closeBlocksResources();
    headResourse.nextElementSibling.classList.toggle("open");
    headResourse.querySelector(".icon").classList.toggle("arrow_rotate");

    setParamToUrl("id", blocksResources[i].id)
  });
}
function closeBlocksResources() {
  for (let block of blocksResources) {
    block.querySelector(".icon").classList.remove("arrow_rotate");
    block.querySelector(".table_resources").classList.remove("open");
  }
}
// END SHOW/HIDE RESOURCES
